/**
 * Reconnect backoff with full jitter (PLAN §5 "Reconnect with exponential backoff and full
 * jitter"): `random(0, min(30 s, 0.5 s × 2^attempt))`. `attempt` starts at 0 when the connection
 * drops, grows after every failed attempt and resets once a connection stayed healthy for 60 s
 * after `hello`. Pure, so tests pass a seeded `rand`.
 */
export const RECONNECT_BASE_MS = 500;
export const RECONNECT_CAP_MS = 30_000;
/** A connection that stayed up this long after `hello` resets `attempt` to 0. */
export const RECONNECT_HEALTHY_AFTER_MS = 60_000;
/** Jitter for the immediate reconnect on `online`, visibility or foreground. */
export const RECONNECT_WAKE_JITTER_MS = 250;
/** Default spread for `system.reconnect` without `afterMs` (close 1012). */
export const RECONNECT_SERVICE_RESTART_MAX_MS = 5_000;

export function reconnectDelayMs(attempt: number, rand: () => number = Math.random): number {
  const exponent = Math.max(0, Math.min(Math.floor(attempt), 30));
  return Math.floor(rand() * Math.min(RECONNECT_CAP_MS, RECONNECT_BASE_MS * 2 ** exponent));
}
